

































































































































































































































import Vue from 'vue';
import { mapState } from 'vuex';
import CryptoJS from 'crypto-js';
import hotsitesServices from '@/services/hub/hotsites';
import AppHeader from '@/components/AppHeader.vue';
import {
  HubButton,
  HubCard,
  HubColorPicker,
  HubHeading,
  HubIcon,
  HubInput,
  HubModal,
  HubPagination,
} from '@/components/HubComponents';
import HotsitesTable from '@/components/Hotsites/HotsitesTable.vue';
import Helpers from '@/utils/Helpers';

export default Vue.extend({
  name: 'ViewChannels',

  components: {
    AppHeader,
    HotsitesTable,
    HubButton,
    HubCard,
    HubColorPicker,
    HubHeading,
    HubIcon,
    HubInput,
    HubModal,
    HubPagination,
  },

  data() {
    return {
      availableCategories: [] as Views.ViewHotsites.AvailableCategories[],
      availableHotsiteType: [
        { text: 'WebTV', value: 'WebTV' },
        { text: 'Gallery', value: 'Gallery' },
      ],

      typePlan: '',

      currentPage: 1,

      editLayoutModalIsOpen: false,

      hotsites: { data: [], total: 0 } as Views.ViewHotsites.Hotsites,
      hotsiteTitle: '',
      hotsiteToBeUpdated: {} as Views.ViewHotsites.Hotsite,

      newHotsiteModalOpen: false,
      numberOfHotsitesPerPage: 5,
      numberOfPagesAvailable: 0,
      numberVideosHomepage: '0',

      orderType: 'DESC' as 'ASC' | 'DESC',

      saveButtonLoading: false,
      search: '',
      selectedCategories: [] as number[],
      selectedHotsiteType: '',
      linkToHotsitePage: '',
      setHotsiteId: 0,
      setCategoryId: 0,

      selectedPrimaryColor: '',
      selectedSecondaryColor: '',

      timeOutId: 0 as unknown as NodeJS.Timeout,

      updateHotsiteModalOpen: false,
    };
  },

  computed: {
    ...mapState(['user']),
    userState(): Store.User.State {
      return this.user;
    },
  },

  watch: {
    currentPage() {
      this.getHotsites();
    },
    orderType(): void {
      this.getHotsites();
    },
    search(): void {
      this.currentPage = 1;

      clearTimeout(this.timeOutId);

      this.timeOutId = setTimeout(() => this.getHotsites(), 500);
    },
  },

  mounted() {
    this.getCategories();
    this.getHotsites();
    this.getCustomerPlan(this.userState.planId)
      .then((data) => {
        localStorage.setItem('user_id', JSON.stringify({ id_customer: data.id_customers }));
      });
  },

  methods: {
    clearModalData(): void {
      this.hotsiteTitle = '';
      this.numberVideosHomepage = '0';
      this.selectedCategories = [];
      this.selectedHotsiteType = '';
    },
    async createHotsite(payload: Services.Hotsites.PostHotsite): Promise<void> {
      return hotsitesServices.postHotsite(payload)
        .then(() => this.showNotification('channel_created_successfully', 'success'))
        .catch((error) => {
          console.error('ViewHotsites - method: "createHotsite()" ', error);

          this.showNotification('error_creating_channel', 'error');

          throw new Error(error);
        });
    },
    formatDate(date: string) {
      return Helpers.formatDate((this.userState.settings.lang as Store.User.Language), date);
    },
    async getCategories(): Promise<void> {
      return hotsitesServices.getCategories(this.userState.planId)
        .then(({ data }) => {
          const { data: categories } = data;

          this.availableCategories = categories.map((category) => ({
            text: category.name,
            value: category.id,
          }));
        })
        .catch((error) => {
          console.error('ViewHotsites - method: "getCategories()" ', error);

          this.showNotification('error_getting_categories', 'error');
        });
    },
    async getHotsitesService(
      payload: Services.Hotsites.GetHotsites,
    ): Promise<Services.Hotsites.Response.GetHotsites | 'error'> {
      return hotsitesServices.getHotsites(payload)
        .then(({ data }) => data)
        .catch((error) => {
          console.error('ViewHotsites - method: "getHotsitesService()" ', error);

          this.showNotification('error_getting_channels', 'error');

          return 'error';
        });
    },
    async getHotsites(): Promise<void> {
      const title = this.search.trim() !== '' ? this.search.trim() : false;

      let payload = {
        actualPage: this.currentPage,
        customerPlanId: parseInt(this.userState.planId, 10),
        orderBy: 'created_at',
        orderType: this.orderType,
        quantity: this.numberOfHotsitesPerPage,
      } as Services.Hotsites.GetHotsites;

      payload = title ? { ...payload, ...{ title } } : payload;

      const response = await this.getHotsitesService(payload);

      if (response === 'error') return;

      this.hotsites = {
        data: response.hotsites.map((hotsite) => ({
          ...hotsite,
          copySuccess: false,
          created_at: this.formatDate(hotsite.created_at),
          linkToHotsitePage: this.getLinkToHotsitePage(hotsite.id),
          selected: false,
        })),
        total: response.total,
      };

      this.numberOfPagesAvailable = Math.ceil(this.hotsites.total / this.numberOfHotsitesPerPage);
    },
    getCustomerPlan(planId: number | string): Promise<Services.User.Response.CustomerPlan> {
      return this.$store.dispatch('user/getCustomerPlan', planId)
        .then((response) => {
          // eslint-disable-next-line prefer-destructuring
          this.typePlan = response.name.split('-')[0];
          if (this.typePlan === 'AVJ') {
            this.availableHotsiteType = [
              { text: 'Gallery', value: 'Gallery' },
            ];
          }
          return response;
        })
        .catch((error) => {
          console.error('Error from getCustomerPlan:', error);
          throw error;
        });
    },

    getLinkToHotsitePage(hotsiteId: number): string {
      const encryptedHotsiteId = CryptoJS.AES.encrypt(
        String(hotsiteId),
        String(process.env.VUE_APP_HOTSITE_SECRET),
      ).toString();

      return `${process.env.VUE_APP_HOTSITE}/${encodeURIComponent(encryptedHotsiteId)}`;
    },
    onClickEdit(hotsite: Views.ViewHotsites.Hotsite): void {
      this.setHotsiteId = hotsite.id;
      this.setCategoryId = hotsite.categories[0].id;
      this.hotsiteTitle = hotsite.title;
      this.numberVideosHomepage = `${hotsite.videos_per_page}`;
      this.selectedCategories = hotsite.categories.map((category) => category.id);
      this.selectedHotsiteType = hotsite.hotsite_type;
      this.linkToHotsitePage = hotsite.linkToHotsitePage;
      this.hotsiteToBeUpdated = hotsite;
      this.updateHotsiteModalOpen = true;
    },
    onClickEditLayout(hotsite: Views.ViewHotsites.Hotsite): void {
      this.selectedPrimaryColor = hotsite.primary_color;
      this.selectedSecondaryColor = hotsite.secondary_color;

      this.hotsiteToBeUpdated = hotsite;
      this.editLayoutModalIsOpen = true;
    },
    onInput(value: string): void {
      if (/\D+/.test(value)) return;

      this.numberVideosHomepage = value;
    },
    onlyNumbers(event: KeyboardEvent): void {
      const evt = event || window.event;
      const expect = `${(evt.target as HTMLInputElement).value.toString()}${evt.key.toString()}`;

      if (!/^\d{0,3}$/.test(expect)) evt.preventDefault();
      else this.numberVideosHomepage = (evt.target as HTMLInputElement).value;
    },
    async onSave() {
      this.saveButtonLoading = true;

      await this.createHotsite({
        categories: this.selectedCategories,
        limitVideosPerPage: parseInt(this.numberVideosHomepage, 10),
        title: this.hotsiteTitle,
        hotsite_type: this.selectedHotsiteType,
      })
        .then(() => {
          this.newHotsiteModalOpen = false;

          this.clearModalData();

          this.getHotsites();
        })
        .catch(() => { /**/ });

      this.saveButtonLoading = false;
    },
    async onUpdate(dataToBeUpdated: 'hotsiteColors' | 'hotsiteData' = 'hotsiteData') {
      this.saveButtonLoading = true;

      const payload = {
        categories: this.selectedCategories,
        hotsiteId: this.hotsiteToBeUpdated.id,
        limitVideosPerPage: parseInt(this.numberVideosHomepage, 10),
        planId: parseInt(this.userState.planId, 10),
        primaryColor: this.selectedPrimaryColor,
        secondaryColor: this.selectedSecondaryColor,
        title: this.hotsiteTitle,
        hotsite_type: this.selectedHotsiteType,
      } as Services.Hotsites.PutHotsite;

      const unchangedData = dataToBeUpdated === 'hotsiteData'
        ? {
          primaryColor: this.hotsiteToBeUpdated.primary_color,
          secondaryColor: this.hotsiteToBeUpdated.secondary_color,
        }
        : {
          categories: this.hotsiteToBeUpdated.categories.map((category) => category.id),
          limitVideosPerPage: this.hotsiteToBeUpdated.videos_per_page,
          title: this.hotsiteToBeUpdated.title,
          hotsite_type: this.hotsiteToBeUpdated.hotsite_type,
        };

      Object.assign(payload, unchangedData);

      await this.updateHotsite(payload)
        .then(() => {
          this.editLayoutModalIsOpen = false;
          this.updateHotsiteModalOpen = false;

          this.clearModalData();

          this.getHotsites();
        })
        .catch(() => { /**/ });

      this.saveButtonLoading = false;
    },
    remove(item: { value: number }): void {
      const index = this.selectedCategories.indexOf(item.value);

      if (index >= 0) this.selectedCategories.splice(index, 1);
    },
    showNotification(text: string, type: 'error' | 'success'): void {
      this.$store.dispatch('notification/create', { text, type });
    },
    async updateHotsite(payload: Services.Hotsites.PutHotsite): Promise<void> {
      return hotsitesServices.putHotsite(payload)
        .then(() => this.showNotification('channel_updated_successfully', 'success'))
        .catch((error) => {
          console.error('ViewHotsites - method: "updateHotsite()" ', error);

          this.showNotification('error_updating_channel', 'error');

          throw new Error(error);
        });
    },
    onClickEditHotsite(): void {
      this.$router.push(`/WebTV/${this.setCategoryId}/${this.setHotsiteId}`);
    },
  },
});
